export default "__VITE_ASSET__2yhbNZSN__"